import { createGlobalStyle } from 'styled-components';
import * as colors from 'src/styles/colors';

/** 轉換為行動板的寬度 */
export const padPoint = '1200px';
export const mobilePoint = '768px';

export const cardZIndex = 100;
export const modalZIndex = 800;
export const tipZIndex = 900;

export const GlobalStyle = createGlobalStyle`
    body {
    font-size: 16px;
    font-family: NotoSansTC-Regular, "Microsoft JhengHei", Arial, sans-serif;
    color: ${colors.BlueGray_800};
    background-color:  ${colors.primaryBlue_30};
    }
    input, textarea {
    font-size: 16px;
    font-family: NotoSansTC-Regular, "Microsoft JhengHei", Arial, sans-serif;
    color: ${colors.BlueGray_800};
    background-color:  ${colors.white};
  }

  /* Remove control buttons of number input  */
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

  a, a:visited, a:hover, a:active {
    color: inherit;
  }
`;
